export const handlePhoneFormat = (value = ''): string => {
  return value
    .substr(0, 11)
    .replace(/^(\d{2})(\d{1})(\d{4})(\d{4})$/, '($1) $2 $3-$4')
    .replace(/^(\d{2})(\d)/, '($1) $2')
    .replace(/ (\d{4})(\d{1,4})$/, ' $1-$2')
}
